/**
 *  Init carousel for promo banner
 */
const initHeaderCarousel = () => {
    var $headerSlider = $(".header-bar .js-content-carousel");
    var speed = $headerSlider.data("speed") ? $headerSlider.data("speed") : "3000";

    if ($headerSlider.length && $headerSlider.children().length > 1) {
        $headerSlider.slick({
            prevArrow: `<button type='button' class='slick-prev-secondary' role='navigation' aria-label='${$headerSlider.data("prev-arrow-label")}'></button>`,
            nextArrow: `<button type='button' class='slick-next-secondary' role='navigation' aria-label='${$headerSlider.data("next-arrow-label")}'></button>`,
            autoplay: true,
            autoplaySpeed: speed,
            pauseOnFocus: false
        });
    }
};

export default function () {
    initHeaderCarousel();
}
